export default __webpack_public_path__ + "static/media/era.050f12e5.jpg";